// offers module types
export const GET_OFFERS_REQUEST = "GET_OFFERS_REQUEST";
export const GET_OFFERS_SUCCESS = "GET_OFFERS_SUCCESS";
export const GET_OFFERS_FAIL = "GET_OFFERS_FAIL";

// offer module types
export const GET_OFFER_REQUEST = "GET_OFFER_REQUEST";
export const GET_OFFER_SUCCESS = "GET_OFFER_SUCCESS";
export const GET_OFFER_FAIL = "GET_OFFER_FAIL";

// product module types
export const GET_OFFERS_PRODUCT_REQUEST = "GET_OFFERS_PRODUCT_REQUEST";
export const GET_OFFERS_PRODUCT_SUCCESS = "GET_OFFERS_PRODUCT_SUCCESS";
export const GET_OFFERS_PRODUCT_FAIL = "GET_OFFERS_PRODUCT_FAIL";

// product module types
export const ADD_OFFERS_REQUEST = "ADD_OFFERS_REQUEST";
export const ADD_OFFERS_SUCCESS = "ADD_OFFERS_SUCCESS";
export const ADD_OFFERS_FAIL = "ADD_OFFERS_FAIL";
